export function preconnectToApiUrl(apiUrl: string) {
  const preconnectLinks = Array.from(document.querySelectorAll('link[rel="preconnect"]')) as HTMLLinkElement[];
  const head = document.querySelector('head');
  const notPreconnected = preconnectLinks.every((link) => !link.href.includes(apiUrl));
  if (notPreconnected) {
    const link = document.createElement('link');
    link.setAttribute('rel', 'preconnect');
    link.setAttribute('href', apiUrl);
    if (head) {
      head.appendChild(link);
    }
  }
}
